import React from 'react';
import { Trans } from '@lingui/react';
import MenuItem from '@material-ui/core/MenuItem';
import TextWithIcon from '@components/TextWithIcon';
import ShareModal from '@organisms/modals/ShareModal';

type Props = {
  className?: string;
  resource: string;
  resourceIdentifier?: string;
  shareURL?: string;
  onModalClose?(): void;
  playlist?: any;
};

const MenuItemShareModal = (props: Props, ref) => {
  const { className, ...otherProps } = props;
  return (
    <ShareModal {...otherProps}>
      {handleOpenModal => (
        <MenuItem ref={ref} onClick={handleOpenModal}>
          <TextWithIcon
            className={className}
            icon="ygb-icon-share"
            iconSize="15px"
          >
            <Trans id="menu_more.share" message="Share" />
          </TextWithIcon>
        </MenuItem>
      )}
    </ShareModal>
  );
};

export default React.forwardRef<any, Props>(MenuItemShareModal);
